import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { systemFont } from "./IOSGroupedList";
import { slidingAccent } from "../styles/mainStyles";

/**
 * Signed-in wallet strip — credits + assistant coins (Settings).
 */
export default function SlidingWalletSummary({
    creditBalance = 0,
    hintPointBalance = 0,
    loading = false,
    onBuyCredits,
    compact = false,
}) {
    const { t } = usePagesTranslation();
    const { tokens } = useSlidingAppearance();

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: compact ? 1 : 1.5 }}>
                <CircularProgress size={22} sx={{ color: slidingAccent }} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                bgcolor: tokens.pillInactiveBg,
                borderRadius: 2,
                px: 2,
                py: compact ? 1.25 : 1.5,
            }}
        >
            <Typography
                sx={{
                    fontFamily: systemFont,
                    fontSize: compact ? "0.8125rem" : "0.875rem",
                    fontWeight: 600,
                    color: tokens.text,
                    mb: 0.5,
                }}
            >
                {t("native.credits.walletTitle", { defaultValue: "Your wallet" })}
            </Typography>
            <Typography
                sx={{
                    fontFamily: systemFont,
                    fontSize: compact ? "0.9375rem" : "1rem",
                    fontWeight: 700,
                    color: slidingAccent,
                    lineHeight: 1.35,
                }}
            >
                {t("native.credits.balanceAndHintPoints", {
                    defaultValue: "{{credits}} credits · {{hints}} assistant coins",
                    credits: creditBalance,
                    hints: hintPointBalance,
                })}
            </Typography>
            {onBuyCredits ? (
                <Button
                    type="button"
                    onClick={onBuyCredits}
                    sx={{
                        mt: 1,
                        fontFamily: systemFont,
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.9375rem",
                        color: slidingAccent,
                        p: 0,
                        minHeight: 44,
                        justifyContent: "flex-start",
                    }}
                >
                    {t("native.credits.buyCredits", { defaultValue: "Buy credits" })}
                </Button>
            ) : null}
        </Box>
    );
}
